// @ is an alias to /src
import ApiService from '@/services/ApiService'

export const namespaced = true

export const state = {
  employeeTypes: [],
  employeeType: {},
}

export const mutations = {
  SET_EMPLOYEE_TYPES(state, employeeTypes) {
    state.employeeTypes = employeeTypes
  },
  SET_EMPLOYEE_TYPE(state, employeeType) {
    state.employeeType = employeeType
  },
  ADD_EMPLOYEE_TYPE(state, employeeType) {
    state.employeeTypes.push(employeeType)
  },
  EDIT_EMPLOYEE_TYPE(state, employeeType) {
    const index = state.employeeTypes.findIndex(
      (el) => el.employee_type_uuid === employeeType.employee_type_uuid
    )
    if (index !== -1) {
      state.employeeTypes.splice(index, 1, employeeType)
    }
  },
  DELETE_EMPLOYEE_TYPE(state, employeeTypeUUID) {
    const index = state.employeeTypes.findIndex(
      (el) => el.employee_type_uuid === employeeTypeUUID
    )
    if (index !== -1) state.employeeTypes.splice(index, 1)
  },
}

export const actions = {
  fetchEmployeeTypes({ commit }, payload) {
    return ApiService.fetchEmployeeTypes(payload)
      .then((res) => {
        const employeeTypes = res.data.data
        commit('SET_EMPLOYEE_TYPES', employeeTypes)
      })
      .catch((error) => {
        throw error
      })
  },
  fetchEmployeeType({ commit, getters, state }, id) {
    if (state.employeeType.employee_type_id === id) {
      return state.employeeType
    }

    const employeeType = getters.getEmployeeTypeById(id)

    if (employeeType) {
      commit('SET_EMPLOYEE_TYPE', employeeType)
      return employeeType
    } else {
      return ApiService.fetchEmployeeType(id)
        .then((res) => {
          const employeeType = res.data
          commit('SET_EMPLOYEE_TYPE', employeeType)
          return employeeType
        })
        .catch((error) => {
          throw error
        })
    }
  },
  addEmployeeType({ commit }, payload) {
    return ApiService.addEmployeeType(payload)
      .then((res) => {
        const employeeType = res.data
        commit('ADD_EMPLOYEE_TYPE', employeeType)
      })
      .catch((error) => {
        throw error
      })
  },
  editEmployeeType({ commit }, payload) {
    return ApiService.editEmployeeType(payload)
      .then((res) => {
        const employeeType = res.data
        commit('EDIT_EMPLOYEE_TYPE', employeeType)
      })
      .catch((error) => {
        throw error
      })
  },
  deleteEmployeeType({ commit }, payload) {
    return ApiService.deleteEmployeeType(payload)
      .then(() => {
        commit('DELETE_EMPLOYEE_TYPE', payload.employeeTypeUUID)
      })
      .catch((error) => {
        throw error
      })
  },
}

export const getters = {
  getEmployeeTypeById: (state) => (id) => {
    return state.employeeTypes.find((el) => el.employee_type_id === id)
  },
}
